import React, { useEffect } from "react"
import ReactPlayer from "react-player/lazy"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const motionSection = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      when: "beforeChildren",
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}

const videoHeader = ({ block }) => {
  const { heading, videoUrl, autoplay } = block

  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.section
      className="section module-bark-rules"
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
    >
      <div className="container">
        <div className="module-image-text__content flex justify-center items-center mb-8">
          {/* <h2 className="w-fit h2 mb-6 relative after:content-[''] after:bg-orange-400 after:h-2 after:w-full after:absolute after:-bottom-4 after:left-0">
            {block.heading}
          </h2> */}
          <h2 className="w-fit h2 mb-6 relative">
            <motion.div variants={title}>{heading}</motion.div>
            <motion.div
              variants={underline}
              className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
            />
          </h2>
        </div>

        <div className="flex max-w-screen-lg mx-auto">
          <motion.div variants={title} className="aspect-w-16 aspect-h-9 mx-auto w-full overflow-hidden rounded-md">
            <ReactPlayer
              url={videoUrl}
              playsinline={autoplay ? true : false}
              muted={autoplay ? true : false}
              controls={autoplay ? false : true}
              playing={autoplay ? true : false}
              loop={autoplay ? true : false}
              width="100%"
              height="100%"
            />
          </motion.div>
        </div>
      </div>
    </motion.section>
  )
}

export default videoHeader
